module.exports = __webpack_public_path__ + "img/1.eb66c952.jpg";